import { render, staticRenderFns } from "./SoundslidesPlayer.vue?vue&type=template&id=5a1d303e&scoped=true&lang=html&"
import script from "./SoundslidesPlayer.vue?vue&type=script&lang=js&"
export * from "./SoundslidesPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SoundslidesPlayer.vue?vue&type=style&index=0&id=5a1d303e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d303e",
  null
  
)

export default component.exports